import { gql } from "@outschool/ui-apollo";
import { ChildFragment, FullCurrentUserFragment } from "@outschool/ui-auth";
import {
  LeaderFragment,
  TeacherVideoModal
} from "@outschool/ui-components-website";

import { ActivityFragment } from "../../shared/client/fragments/ActivityFragments";
import { getLearnerItems } from "../components/enrolling/enrollmentForm/learnerItems/getLearnerItems";
import EnrollmentFragment from "./EnrollmentFragment";
import LearnerFragment from "./LearnerFragment";
import { SectionFragment } from "./SectionFragments";

export const CommonEnrollmentFormUserFragment = gql`
  fragment CommonEnrollmentFormUserFragment on User {
    ...FullCurrentUserFragment
    consented_to_coppa_notice_at
    children {
      ...ChildFragment
    }
    lastSubmittedEnrollments {
      ...getLearnerItems_enrollment
    }
  }
  ${ChildFragment}
  ${getLearnerItems.fragments.enrollment}
  ${FullCurrentUserFragment}
  ${LearnerFragment}
`;

export const CommonEnrollmentFormActivityFragment = gql`
  fragment CommonEnrollmentFormActivityFragment on Activity {
    uid
    leader {
      uid
      ...LeaderFragment
      ...TeacherVideoModal_teacher
    }
    strictAgeRange {
      min
      max
    }
    suggestedWeeklyMeetings
    reviewCount
    esaStatus(esaState: $esaState)
    pricingInfo {
      totalPriceCentsForUpfrontPayment
      totalPriceCentsForWeeklyPayments
      weeklyPriceCentsForUpfrontPayment
      weeklyPriceCentsForWeeklyPayments
      upfrontDiscountPercentage

      totalPriceCreditsForUpfrontPayment
      weeklyPriceCreditsForUpfrontPayment
      totalPriceCreditsForWeeklyPayments
      weeklyPriceCreditsForWeeklyPayments
    }
    ...ActivityFragment
  }
  ${ActivityFragment}
  ${LeaderFragment}
  ${TeacherVideoModal.fragments.teacher}
`;

export const CommonEnrollmentFormSectionFragment = gql`
  fragment CommonEnrollmentFormSectionFragment on Section {
    uid
    filledSpaceCount
    leader {
      uid
      name
      hasBackgroundCheckExpired
      ownerOfSellerOrg {
        uid
      }
      ...TeacherVideoModal_teacher
    }
    allowsLateEnrollment
    progress {
      pastMeetingCount
      remainingMeetingCount
      totalMeetingCount
      nextMeeting {
        start_time
      }
    }
    syllabus {
      uid
      lessons {
        uid
      }
    }
    ...SectionFragment
  }
  ${SectionFragment}
`;

export const ActivityEnrollQuery = gql`
  query ActivityEnrollQuery($sectionUid: ID!, $esaState: String) {
    currentUser {
      ...CommonEnrollmentFormUserFragment
    }
    enrollmentForm(sectionUid: $sectionUid) {
      uid
      section {
        uid
        ...CommonEnrollmentFormSectionFragment
      }
      activity {
        ...CommonEnrollmentFormActivityFragment
        esaStatus(esaState: $esaState)
      }
      currentUserEnrollments {
        ...EnrollmentFragment
        ...getLearnerItems_enrollment
      }
      conflictingEnrollments {
        ...getLearnerItems_enrollment
      }
      pendingEnrollments {
        ...getLearnerItems_enrollment
      }
      waitlistSeatsCount
    }
  }
  ${CommonEnrollmentFormUserFragment}
  ${CommonEnrollmentFormActivityFragment}
  ${CommonEnrollmentFormSectionFragment}
  ${TeacherVideoModal.fragments.teacher}
  ${EnrollmentFragment}
  ${getLearnerItems.fragments.enrollment}
`;

export const ActivitySelfPacedEnrollQuery = gql`
  query ActivitySelfPacedEnrollQuery($activityUid: ID!, $esaState: String) {
    currentUser {
      ...CommonEnrollmentFormUserFragment
    }
    selfPacedEnrollmentForm(activityUid: $activityUid) {
      uid
      activity {
        ...CommonEnrollmentFormActivityFragment
        esaStatus(esaState: $esaState)
        syllabus {
          uid
          lessons {
            uid
          }
        }
      }
      currentUserEnrollments {
        ...EnrollmentFragment
        ...getLearnerItems_enrollment
      }
      pendingEnrollments {
        ...getLearnerItems_enrollment
      }
    }
  }
  ${CommonEnrollmentFormUserFragment}
  ${CommonEnrollmentFormActivityFragment}
  ${SectionFragment}
  ${EnrollmentFragment}
  ${getLearnerItems.fragments.enrollment}
`;
